export default __webpack_public_path__ + "fonts/21f3b5d1cf4c3e4bb79ffa7ac3a524ec.svg";